/**
 * File track-new-nav.js.
 * Handles firing Segment events when the new navigation is used.
 */

const navButtons = document.querySelectorAll('button.nav-btn');
const navOverlay = document.querySelector('.header__nav-overlay');
const navHeader = document.querySelector('.header');
const sidebar = document.querySelector('.header__nav');

function createSegmentProperties(actionDetail) {
  return {
    interaction_type: "INTERACTION_TYPE_NAVIGATION_BAR_INTERACTION",
    interaction_details: {
      action_detail: actionDetail
    }
  };
}

// Handles clicks on sidebar nav buttons
function handleSidebarButtonClick(button) {
  const isOpening = button.classList.contains('nav-btn--open') && !button.classList.contains('is-active');
  const actionDetail = isOpening ? "Sidebar Opened" : "Sidebar Closed";

  if (typeof segmentGenericEvent === 'function') {
    segmentGenericEvent('track', createSegmentProperties(actionDetail));
  }
}

// Handles clicks on the nav overlay (outside the sidebar)
function handleOverlayClick() {
  if (typeof segmentGenericEvent === 'function') {
    segmentGenericEvent('track', createSegmentProperties("Sidebar Closed"));
  }
}

// Handles clicks on the header (to close sidebar if open and click is outside sidebar)
function handleHeaderClick(e) {
  const sidebarIsOpen = document.querySelector('.nav-btn--open.is-active');
  if (sidebarIsOpen && !sidebar.contains(e.target)) {
    if (typeof segmentGenericEvent === 'function') {
      segmentGenericEvent('track', createSegmentProperties("Sidebar Closed"));
    }
  }
}

if (navButtons) {
  navButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent click from bubbling up to header
      handleSidebarButtonClick(e.currentTarget);
    });
  });
}

if (navOverlay) {
  navOverlay.addEventListener('click', handleOverlayClick);
}

if (navHeader) {
  navHeader.addEventListener('click', handleHeaderClick);
}